import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import { message } from "../../components/antdMessageBridge";
import ConfirmationModalStopImg from "../../assets/img/svg/xreportprocessing.svg";

const ReportModal = (props) => {
    const navigate = useNavigate();
    const handleCancel = () => {
        props.setVisible(false);
    }
    const handleClick = () => {
        navigate(`/${props.queueURL}`); // Redirects to the /about route
    };
    return (
        <Modal
            title={props.title}
            open={props.Visible}
            // onCancel={handleCancel}
            // onClose={handleCancel}
            footer={null}
            className="recycle-manifest-model stop-modal report-stop-modal"
            width={760}
        >
            <div className="modal-divider">
                <img src={ConfirmationModalStopImg} alt="Modal Stop" className="modal-header-img"></img>
                {/*<span>{props.modalBody}</span>*/}
                <span dangerouslySetInnerHTML={{ __html: props.modalBody }} />
            </div>            
            <div className="modal-button-container">
                <button className="submit-button-gradiant-outline-fill" type="submit" onClick={handleClick}><span>Go to Download Queue</span></button>
                <button className="accept-button" type="submit" onClick={handleCancel}>Continue</button>
            </div>           
        </Modal>
    );
}

export default ReportModal;